import React from 'react';
import {useSelector} from 'react-redux';
import { Collapse, Button } from 'antd';
import stylesRiepilogo from '../Riepilogo.module.scss';
import moment from 'moment';
import Immagine from '../../../../components/Immagine/Immagine';

const { Panel } = Collapse;

const PanelSituazioneLavorativa = (props) => {

    const datiSteps = useSelector(state => state.dataReducer.modello.datiPratica);

    return (
        <Collapse expandIcon={({ isActive }) =>  isActive ? <Immagine urlImage={'menus.svg'} name="CLOSE" class={stylesRiepilogo.immagineCollapse} /> : <Immagine urlImage={'plus.svg'} name="OPEN" class={stylesRiepilogo.immagineCollapse} />  }>
            <Panel header={props.headerPanel} key={props.chiave}>
                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Situazione lavorativa</h3>
                        <Button onClick={() => props.tornaAlloStep(9)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                Attività
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                {
                                    datiSteps.attivita === 'S' ? 'Autonomo' :
                                    datiSteps.attivita === 'D' ? 'Dipendente' :
                                    datiSteps.attivita === 'P' ? 'Pensionato' :
                                    null
                                }
                                </div>
                            </div>

                            {
                                datiSteps.attivita === 'S' ? (

                                    <>
                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                                Occupazione
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                                {
                                                    datiSteps.occupazioneAutonomo === 'ART' ? 'Artigiano'
                                                    : datiSteps.occupazioneAutonomo === 'AUT' ? 'Imprenditore'
                                                    : datiSteps.occupazioneAutonomo === 'PRO' ? 'Professionista'
                                                    : null
                                                }
                                            </div>
                                        </div>

                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                            Data inizio attività
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                            {moment(datiSteps.dataInizioAttivita).format('DD/MM/YYYY')}
                                            </div>
                                        </div>

                                    </>

                                ) : datiSteps.attivita === 'D' ? (

                                    <>
                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                                Occupazione
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                                {
                                                    datiSteps.occupazioneDipendente === 'OPE' ? 'Operaio'
                                                    : datiSteps.occupazioneDipendente === 'IMP' ? 'Impiegato'
                                                    : datiSteps.occupazioneDipendente === 'QUA' ? 'Quadro'
                                                    : datiSteps.occupazioneDipendente === 'DIR' ? 'Dirigente'
                                                    : null
                                                }
                                            </div>
                                        </div>

                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                                Settore attività
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                                {
                                                    datiSteps.settoreAttivita === 'P' ? 'Privato'
                                                    : datiSteps.settoreAttivita === 'S' ? 'Stato, Parastato Enti Pubblici'
                                                    : null
                                                }
                                            </div>
                                        </div> 

                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                                Tipo contratto
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                                {
                                                    datiSteps.tipoContratto === '1' ? 'Tempo indeterminato'
                                                    : datiSteps.tipoContratto === '2' ? 'Tempo determinato'
                                                    : datiSteps.tipoContratto === '3' ? 'Part Time indeterminato'
                                                    : datiSteps.tipoContratto === '4' ? 'Part Time determinato'
                                                    : null
                                                }
                                            </div>
                                        </div>  

                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                                Data inizio attività
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                                {moment(datiSteps.dataInizioAttivita).format('MM/YYYY')}
                                            </div>
                                        </div>

                                        {datiSteps.dataFineAttivita !== null && datiSteps.dataFineAttivita !== '' ? (

                                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                                <div className={stylesRiepilogo.leftRiepilogo}>
                                                    Data fine attività
                                                </div>
                                                <div className={stylesRiepilogo.rightRiepilogo}>
                                                    {moment(datiSteps.dataFineAttivita).format('MM/YYYY')}
                                                </div>
                                            </div> 
                                        )
                                        : null
                                        }
                                    </>

                                ) : null
                            }

                            {
                                ( datiSteps.attivita === 'S' || datiSteps.attivita === 'D') ? (

                                    <>
                                        <div className={stylesRiepilogo.rigaRiepilogo}>
                                            <div className={stylesRiepilogo.leftRiepilogo}>
                                                Ragione sociale azienda
                                            </div>
                                            <div className={stylesRiepilogo.rightRiepilogo}>
                                                {datiSteps.ragioneSocialeAzienda}
                                            </div>
                                        </div>
                                    </>
                            
                                ) : null
                            }
                            
                        </div>
                    </div>



                    <div className={stylesRiepilogo.Riepilogo}>
                        <h3 className={stylesRiepilogo.titoloRiepilogo}>Reddito mensile</h3>
                        <Button onClick={() => props.tornaAlloStep(10)} className={stylesRiepilogo.TornoIndietro}>Modifica</Button>
                        <div className={stylesRiepilogo.tabellaRiepilogo}>

                            <div className={stylesRiepilogo.rigaRiepilogo}>
                                <div className={stylesRiepilogo.leftRiepilogo}>
                                    Reddito mensile netto
                                </div>
                                <div className={stylesRiepilogo.rightRiepilogo}>
                                    {datiSteps.redditoMensileNetto}€
                                </div>
                            </div>

                            {
                                datiSteps.attivita === 'D' ? (

                                <div className={stylesRiepilogo.rigaRiepilogo}>
                                    <div className={stylesRiepilogo.leftRiepilogo}>
                                        Reddito mensilità
                                    </div>
                                    <div className={stylesRiepilogo.rightRiepilogo}>
                                        {datiSteps.redditoMensilita} mesi
                                    </div>
                                </div>

                                ) : null 
                            }

                        </div>
                    </div>

                </Panel>
        </Collapse>
    )
}

export default PanelSituazioneLavorativa;